import { PortfolioSituation } from "../types/ownerPortfolio.types";

export const SITUATION_BADGE_CLASS: Record<PortfolioSituation, string> = {
  ALUGADO: "bg-[#3fb950]/15 text-[#3fb950]",
  ALUGANDO: "bg-[#6ea8ff]/15 text-[#6ea8ff]",
  EM_RESCISAO: "bg-[#f85149]/15 text-[#f85149]",
  EM_MANUTENCAO: "bg-[#d29922]/15 text-[#d29922]",
};
